// All out customized styles are based on react-toastify version 5.5

import { styled } from '@creditas/stylitas'

import { toastContainer } from './toastContainer'
import { toast } from './toast'
import { progressBar } from './progressBar'
import { closeButton } from './closeButton'
import { zoom } from './animations/zoom'
import { bounce } from './animations/bounce'
import { flip } from './animations/flip'
import { slide } from './animations/slide'

const Container = styled.div`
  ${toastContainer}
  ${toast}
  ${progressBar}
  ${closeButton}
  ${zoom}
  ${bounce}
  ${flip}
  ${slide}
`

export { Container }
